/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import { useState } from "react";
import { NavLink as NavLinkRRD, Link, useNavigate } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

// Importar el contexto de autenticación
import { useAuth } from "../../context/AuthContext";
import UserMenu from "../UserMenu";

var ps;

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState();
  const { user } = useAuth();
  const navigate = useNavigate();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };



  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      // Filtrar rutas según el rol del usuario
      if (prop.adminOnly && user?.rol !== 'administrador') {
        return null;
      }
      // Ocultar rutas marcadas como hideInNav (se renderizan manualmente)
      if (prop.hideInNav) {
        return null;
      }

      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
          >
            <i className={prop.icon} />
            <span className="d-flex align-items-center justify-content-between w-100">
              <span>{prop.name}</span>
              {prop.path === "/reportes" && (
                <>
                  <style>{`
                    @keyframes badge-new-flash {
                      0%   { box-shadow: 0 0 3px #ff3b30, 0 0 6px #ff3b30; }
                      50%  { box-shadow: 0 0 8px #ff3b30, 0 0 14px #ff3b30; }
                      100% { box-shadow: 0 0 3px #ff3b30, 0 0 6px #ff3b30; }
                    }
                    .badge-new {
                      background: #ffeb3b;
                      color: #212529;
                      font-size: 9px;
                      font-weight: 800;
                      padding: 2px 6px;
                      border-radius: 6px;
                      text-transform: uppercase;
                      line-height: 1;
                      letter-spacing: 0.5px;
                      animation: badge-new-flash 1.5s infinite ease-in-out;
                      display: inline-block;
                    }
                  `}</style>
                  <span className="badge-new">New</span>
                </>
              )}
            </span>
          </NavLink>
        </NavItem>
      );
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center w-100">
          {/* Lado izquierdo - Toggler y Brand */}
          <div className="d-flex align-items-center">
            {/* Toggler */}
            <button
              className="navbar-toggler"
              type="button"
              onClick={toggleCollapse}
            >
              <span className="navbar-toggler-icon" />
            </button>
            {/* Brand */}
            {logo ? (
              <NavbarBrand className="pt-0" {...navbarBrandProps}>
                <img
                  alt={logo.imgAlt}
                  className="navbar-brand-img"
                  src={logo.imgSrc}
                />
              </NavbarBrand>
            ) : null}
          </div>

          {/* Lado derecho - Usuario en móviles */}
          <div className="d-lg-none">
            <UserMenu variant="mobile" />
          </div>
        </div>

        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen} className="d-flex flex-column h-100 flex-grow-1">
          {/* Collapse header */}
          <div className="navbar-collapse-header d-lg-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>

          {/* Navigation */}
          <Nav navbar className="flex-grow-1" style={{ overflowY: "auto" }}>
            {createLinks(routes)}
            {/* Espacio después del menú Estadísticas / Reportes */}
            <NavItem style={{ height: "96px" }} />
          </Nav>

          {/* Bloque "¿Necesitas ayuda?" estilo Argon */}
          <div
            style={{
              marginTop: "auto",
              marginLeft: "12px",
              marginRight: "12px",
              marginBottom: "16px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #5e17eb 0%, #11cdef 100%)",
              padding: "16px 14px 14px",
              textAlign: "center",
              boxShadow: "0 4px 18px rgba(94, 23, 235, 0.25)",
            }}
          >
            <p
              style={{
                color: "#fff",
                fontWeight: "700",
                fontSize: "0.85rem",
                marginBottom: "12px",
              }}
            >
              ¿Necesitas ayuda?
            </p>
            <Link
              to="/a/soporte"
              onClick={closeCollapse}
              className="btn btn-block"
              style={{
                background: "rgba(255,255,255,0.15)",
                border: "1px solid rgba(255,255,255,0.45)",
                color: "#fff",
                fontWeight: "600",
                fontSize: "0.78rem",
                borderRadius: "8px",
                padding: "6px 10px",
                display: "block",
                textDecoration: "none",
                transition: "background 0.2s",
              }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.28)"}
              onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.15)"}
            >
              Contactar Soporte
            </Link>
          </div>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
